import config from 'config'
import * as dateMenuSelectors from 'menu/DateMenu/selectors'
import { createLogic } from 'redux-logic'
import { fetchAction } from 'utils'

import * as actions from './actions'
import { FETCH_CHANNELS_FLOORSPACE } from './constants'

const fetchChannelsFloorspace = createLogic({
  type: FETCH_CHANNELS_FLOORSPACE,
  latest: true,

  async process({ getState }, dispatch, done) {
    const baseRequestParams = dateMenuSelectors.baseRequestParams(getState())

    try {
      const response = await fetchAction(config.api.channelsFloorspace, baseRequestParams)

      dispatch(actions.channelsFloorspaceSuccess(response.data))
    } catch (e) {
      dispatch(actions.channelsFloorspaceError())
    }

    done()
  },
})

export default [fetchChannelsFloorspace]
